import React from 'react';
import { Formik, Form } from 'formik';
import { Button, Divider } from 'antd';
import PropTypes from 'prop-types';
import { FormInput } from '../Input/InputText';
import { PatientDetailsValidationSchema } from '../../utils/FormValidation';

const PatientDetailsForm = ({ userType, onSubmit }) => {
  return (
    <Formik
      initialValues={{
        name: '',
        email: '',
        phoneNo: '',
        isLogin: false,
        casePaperNo: '',
      }}
      validationSchema={PatientDetailsValidationSchema}
      onSubmit={onSubmit}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        <Form>
          <div className="row">
            <div className="my-2">
              <Divider style={{ fontWeight: '600' }}>Patient Details</Divider>
            </div>
            {userType === 'old' && (
              <FormInput
                label="Case Paper No."
                type="casePaperNo"
                FormGroupClassName={'col-xl-6 col-md-12'}
                LabelClassName={'col-form-label'}
                name="casePaperNo"
                onChange={handleChange}
                FormControlClassName={'form-control '}
                onBlur={handleBlur}
                error={errors.casePaperNo}
                value={values.casePaperNo}
                touched={touched.casePaperNo}
                placeholder={'Enter Your Case Paper No.'}
              />
            )}

            <FormInput
              label="Name"
              type="name"
              FormGroupClassName={'col-xl-6 col-md-12'}
              LabelClassName={'col-form-label'}
              name="name"
              onChange={handleChange}
              FormControlClassName={'form-control '}
              onBlur={handleBlur}
              error={errors.name}
              value={values.name}
              touched={touched.name}
              placeholder={'Enter Your name'}
            />

            <FormInput
              label="email"
              type="email"
              FormGroupClassName={'col-xl-6 col-md-12'}
              LabelClassName={'col-form-label'}
              name="email"
              onChange={handleChange}
              FormControlClassName={'form-control '}
              onBlur={handleBlur}
              error={errors.email}
              value={values.email}
              touched={touched.email}
              placeholder={'Enter Your email'}
            />

            <FormInput
              label="Phone No"
              type="phoneNo"
              FormGroupClassName={'col-xl-6 col-md-12'}
              LabelClassName={'col-form-label'}
              name="phoneNo"
              onChange={handleChange}
              FormControlClassName={'form-control '}
              onBlur={handleBlur}
              error={errors.phoneNo}
              value={values.phoneNo}
              touched={touched.phoneNo}
              placeholder={'Enter Your phoneNo'}
            />

            <div className="col-12">
              <div className="text-end">
                <Button
                  onClick={() => {
                    handleSubmit();
                  }}
                  type="primary"
                  disabled={isSubmitting}
                  className="pb-4"
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

PatientDetailsForm.propTypes = {
  userType: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default React.memo(PatientDetailsForm);
